/**
 * Makes menu sticky.
 */

import stickybits from 'stickybits';

jQuery( $ => { // eslint-disable-line no-unused-vars
	const disableStickyMenu = wp.hooks.applyFilters( 'qala_theme.filter.pre_disable_sticky_menu', false );
	if ( ! disableStickyMenu ) {
		const stickyArgs = {
			useStickyClasses: true,
		};

		stickybits( '.site-header', stickyArgs );
	}
} );
